import { z } from 'zod/v4'

export const faqValidation = () => {
  return z.object({
    question: z.string().min(1, { message: 'Question is required' }),
    answer: z.string().min(1, { message: 'Answer is required' }),
    keyword: z.string().array().min(1, { message: 'At least one keyword is required' }),
  })
}